import React, {memo} from "react";

import useFeatures from "Hooks/useFeatures";

/**
 * `withFeatures` HOC wrapper
 *
 * Makes the active features list available on a component as `features`.
 *
 * @package HOPS
 * @subpackage Hoc
 * @copyright Heritage Operations Processing Limited
 */
const withFeatures = Component => {
	return memo(props => {
		const {features, featuresAvailable, featuresForced, isFeatureEnabled, isLiveFeature, isPreviewFeature} = useFeatures();
		return <Component
			{...props}
			features={features}
			featuresAvailable={featuresAvailable}
			featuresForced={featuresForced}
			isFeatureEnabled={isFeatureEnabled}
			isLiveFeature={isLiveFeature}
			isPreviewFeature={isPreviewFeature} />;
	});
};

export default withFeatures;
